import React from "react";
import Loading from "../../../ui-components/loading/loading";
import { ReactComponent as Group } from "../../../images/in-house.svg";
import { ReactComponent as Profile } from "../../../images/agent.svg";
import { ReactComponent as Valvesvgrepo } from "../../../images/globe.svg";
import { ReactComponent as MapMarker } from "../../../images/map-marker.svg";
import { cn } from "services/common/className";

export enum TerminalSummaryTileTypes {
    totalTerminals = "totalTerminals",
    activeAgents = "activeAgents",
    distributors = "distributors",
    regions = "regions"
}
interface TerminalSummaryTileProps {
    type: TerminalSummaryTileTypes;
    isLoading: boolean;
    title: string;
    value: string | number;
    clicked?: boolean;
    onClick?: () => void;
    onClear?: () => void;
}

const getTileIcon = (type: TerminalSummaryTileTypes) => {
    if (type === "totalTerminals") return <Group />;
    else if (type === "activeAgents") return <Profile />;
    else if (type === "distributors") return <Valvesvgrepo />;
    else if (type === "regions") return <MapMarker />;
    else return "";
}

export const TerminalSummaryTile: React.FC<TerminalSummaryTileProps> = (props) => {
    const cnTile = cn("xgs-terminallist-summary__tile");

    return (<div className={cnTile({
        enabled: props.clicked,
        clickable: props.type !== "regions",
    })}>
        <div className={`icon-container --type-${props.type}`}>
            {getTileIcon(props.type)}
        </div>
        <div className="content">
            {props.isLoading ?
                <Loading isLoading={true} /> :
                <div className="info_terminal_summary">
                    <div className="value">{props.value}</div>
                </div>
            }
            <div className="info_terminal_summary">
                <div className="title">{props.title}</div>
                {props.type !== "regions" && (props.clicked ? <div
                    className="apply"
                    onClick={props.onClear}
                >
                    Clear Filter
                </div> : <div
                    className="apply"
                    onClick={props.onClick}
                >
                    Apply
                </div>)}
            </div>
        </div>
    </div>
    )
};